import { Box, Flex, Text, Image, HStack } from "@chakra-ui/react";
import { IconType } from "react-icons";

// Importações das imagens
import TodosImg from "../../../../../assets/Portaria/Todos.png";
import RecebimentosImg from "../../../../../assets/Portaria/Recebimentos.png";
import ExpedicoesImg from "../../../../../assets/Portaria/Expedicoes.png";
import DevolucoesImg from "../../../../../assets/Portaria/Devolucoes.png";
import SaidasImg from "../../../../../assets/Portaria/Saidas.png";
import FinalizadasImg from "../../../../../assets/Portaria/Finalizadas.png";

// Interface
export interface ResumoCardProps {
  label: "Todos" | "Recebimentos" | "Expedições" | "Devoluções" | "Saídas" | "Finalizadas";
  value: number | string;
  icon: IconType;
  iconColor: string;
  borderColor?: string;
  onClick: (label: ResumoCardProps["label"]) => void;
}

const imageMap: Record<ResumoCardProps["label"], string> = {
  Todos: TodosImg,
  Recebimentos: RecebimentosImg,
  Expedições: ExpedicoesImg,
  Devoluções: DevolucoesImg,
  Saídas: SaidasImg,
  Finalizadas: FinalizadasImg,
};

export function ResumoCard({
  label,
  value,
  icon: Icon,
  iconColor,
  borderColor = "transparent",
  onClick,
}: ResumoCardProps) {
  const chartImage = imageMap[label];

  return (
    <Box
      bg="blue.50"
      pb={4}
      p={2}
      borderRadius="md"
      border="2px solid"
      borderColor={borderColor}
      boxShadow="sm"
      cursor="pointer"
      onClick={() => onClick(label)}
    >
      <Flex align="center" gap={2} mb={2}>
        <Box color={iconColor} fontSize="xl">
          <Icon />
        </Box>
        <Text fontWeight="bold">{label}</Text>
      </Flex>
      <HStack w={'100%'} align="center" gap={2}>
        <Text fontSize="2xl" fontWeight="bold">
          {value}
        </Text>
        <Box justifyContent={'flex-end'} w={'100%'}>
          <Image w={'100px'} src={chartImage} alt={`Gráfico de ${label}`} mt={1} h="36px" />
        </Box>
      </HStack>
    </Box>
  );
}
